export const isDev = (): boolean => {
  return import.meta.env.VITE_APP_ENV === "development";
};

export const isProd = (): boolean => {
  return import.meta.env.VITE_APP_ENV === "production";
};

export const getEnvironment = (): "development" | "staging" | "production" => {
  return import.meta.env.VITE_APP_ENV;
};

export const isInternalAppStaging = (): boolean => {
  return import.meta.env.VITE_SERVER_URL?.includes("staging-internal");
};

declare global {
  interface Window {
    Cypress?: unknown;
  }
}

export const isCypressTest = (): boolean => {
  return !!window.Cypress;
};

function getServerUrl(): string {
  // Use an explicit URL when set (local dev or BE preview deployments pointing at a preview Lambda).
  // Otherwise fall back to relative URLs so same-origin CloudFront routing works in staging/prod.
  if (import.meta.env.VITE_SERVER_URL) {
    return import.meta.env.VITE_SERVER_URL;
  }
  return "";
}

// TODO: Temporary function to call FarGate setup until we've fully converted over the internal API
function getEcsServerUrl(): string {
  if (isDev()) {
    return import.meta.env.VITE_SERVER_URL;
  } else {
    // There's only a staging version of the ecs service
    return "https://staging-internal-api.adora-ai.com";
  }
}

export const RelativeUrl = getServerUrl() + "/api";
export const EcsRelativeUrl = getEcsServerUrl() + "/api";
